import { render } from "./MyTopBarButtonSignUp.vue?vue&type=template&id=369faebd"
import script from "./MyTopBarButtonSignUp.vue?vue&type=script&lang=js"
export * from "./MyTopBarButtonSignUp.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__